import React from 'react'

import { Text } from '@primer/components'

import { CATEGORY_MAINTAINABILITY as category } from '../../constants'
import { IMPACT_HIGH as impact } from '../../constants'

export const exampleTitle = 'settings.py'

export const exampleBefore = (
`MIDDLEWARE =[
    "django.contrib.auth.middleware.AuthenticationMiddleware",
    "django.contrib.sessions.middleware.SessionMiddleware",
    ...
]`
)

export const exampleAfter = (
`MIDDLEWARE =[
    "django.contrib.sessions.middleware.SessionMiddleware",
    "django.contrib.auth.middleware.AuthenticationMiddleware",
    ...
]`
)

export const code = 'C4000'


export const title = 'Middleware order'

export const wordCode = 'middleware-order'

export const furtherReading = [
  {
    href: 'https://djangodoctor.medium.com/what-you-dont-know-about-middleware-ordering-could-hurt-your-website-22b92946bb19',
    text: 'Our blog post on the topic',
  },
  {
    href: 'https://docs.djangoproject.com/en/dev/ref/middleware/#middleware-ordering',
    text: 'Django middleware order documentation',
  },
]

export function Summary(proc400ps) {
  return (
    <>
      <Text as={'p'}>The order of middleware affections the outcome.</Text>
      <Text as={'p'}>Some middleware are dependant on the functionality of other middleware. For example a middleware that requires usage of request.session should come after the SessionMiddleware.</Text>
    </>
  )
}

export const ogImage = "/og-image/C4000.png"
export {category, impact}